import jwtDecode from 'jwt-decode'

import convertKeys from './convert-keys'

export const parseToken = (token) => {
  try {
    return convertKeys.toCamel(jwtDecode(token))
  } catch (error) {
    return {}
  }
}
